export default __webpack_public_path__ + "static/media/jquery.805a7ce8.svg";